module.exports = __webpack_public_path__ + "static/media/image_18.a8a2f2cb.png";